import { inIFrame } from '@thoughtspot/browser-util';
import { envFlags, FLAGS } from '@thoughtspot/env-flags';
import React from 'react';
export const EmbedBaseLink = ({ children, ...restProps }) => {
    const updatedProps = { ...restProps };
    const shouldDisableLinks = envFlags.getValue(FLAGS.disableRedirectionLinksInNewTab.name);
    if (shouldDisableLinks) {
        delete updatedProps.href;
        if (!updatedProps.onClick && restProps.href) {
            updatedProps.onClick = () => {
                window.open(restProps.href, '_self');
            };
        }
    }
    return React.createElement("a", { ...updatedProps }, children);
};
export const BaseLink = ({ children, ...restProps }) => {
    if (inIFrame()) {
        return React.createElement(EmbedBaseLink, { ...restProps }, children);
    }
    return React.createElement("a", { ...restProps }, children);
};
//# sourceMappingURL=base-link.js.map